<script setup lang="ts">
import { Locales, usePrevioCore } from '@previo/core'
import {
  PFlag,
  PFlagSize,
  PSelectInputField,
  PSpace,
  PSpaceSize,
  PTextFormBody,
} from '@previo/design-system'
import { ref, watch } from 'vue'
import { CountryISO3 } from '@previo/codebooks'
import { idLocaleManager } from '~/composables/translate'
import type { Locale } from '~/layouts/components/Locale'

const { useLocale } = usePrevioCore()

const selectedLocale = ref<Locales>(useLocale().get())

const locales: Locale[] = [
  {
    locale: Locales.CS,
    countryIso3: CountryISO3.CZE,
    text: 'Čeština',
  },
  {
    locale: Locales.EN,
    countryIso3: CountryISO3.GBR,
    text: 'English',
  },
  {
    locale: Locales.HR,
    countryIso3: CountryISO3.HRV,
    text: 'Hrvatski',
  },
  {
    locale: Locales.HU,
    countryIso3: CountryISO3.HUN,
    text: 'Magyar',
  },
  {
    locale: Locales.PL,
    countryIso3: CountryISO3.POL,
    text: 'Polski',
  },
  {
    locale: Locales.DE,
    countryIso3: CountryISO3.DEU,
    text: 'Deutsch',
  },
  {
    locale: Locales.RO,
    countryIso3: CountryISO3.ROU,
    text: 'Românesc',
  },
  {
    locale: Locales.SK,
    countryIso3: CountryISO3.SVK,
    text: 'Slovenčina',
  },
]

watch(selectedLocale, (locale: Locales) => {
  if (locale) {
    idLocaleManager.setLocale(locale)
  }
})
</script>

<template>
  <div class="id-switch-locale">
    <p-select-input-field
      v-model="selectedLocale"
      :items="locales"
      item-text="text"
      item-value="locale"
      disable-clearable
      cy="change-locale"
    >
      <template #selected="{ item }: { item: Locale }">
        <div class="p-flex p-items-center p-no-wrap">
          <p-flag :country-iso3="item.countryIso3" :size="PFlagSize.SMALL" />
          <p-space :mobile="PSpaceSize.SM" />
          <p-text-form-body :text="item.text" />
        </div>
      </template>

      <template #item="{ item }: { item: Locale }">
        <p-space :mobile="PSpaceSize.SM" />
        <p-flag :country-iso3="item.countryIso3" :size="PFlagSize.SMALL" />
        <p-space :mobile="PSpaceSize.SM" />
        <p-text-form-body :text="item.text" />
        <p-space :mobile="PSpaceSize.SM" />
      </template>
    </p-select-input-field>
  </div>
</template>

<style lang="scss" scoped>
@import '@previo/design-system/src/assets/scss/shared/mixins';

.id-switch-locale {
  @include laptopAndLarge {
    width: 170px;
  }
}
</style>
